const ua = require('./module/ua.js');
const inview = require('./module/inview.js');
const playYt = require('./module/yt_api.js')

$(window).on('load', function(){
	setTimeout(function(){
		$('.loading').addClass('is--hide');
	},1000);
	setTimeout(function(){
		inview();
		if(ua('iphone') || ua('android')) {
		}else{
			//playYt($('body').data('ytid01'), 'movie01', 1);
			playYt($('body').data('ytid02'), 'movie02', 1);
		}

	},1500);
	var count = 2;
	setInterval(function(){
		$('.slider--top li').removeClass('is--active');
		$('.slider--top li:nth-of-type(' + count + ')').addClass('is--active');
		if(count == 3){
			count = 1;
		}else{
			count++;
		}
	}, 5000);
});

$(function(){
	$(window).on('scroll', function(){
		inview();
	});
	$(document).on('click', '.link--scroll', function(e,){
		e.preventDefault();
		$( 'html,body' ).animate( { scrollTop: $( $( this ).attr( 'href' ) ).offset().top - 65 }, 'swing' );
	});
	$(document).on('click', '.menu-trigger', function(e){
		e.preventDefault();
		$(this).toggleClass('is--active');
		$('.gnav').toggleClass('is--active');
		$('.header .title').toggleClass('is--active');
	});
	$(window).on('scroll', function(){
		var top = $(window).scrollTop();

		if(top > 500){
			$('.btn--pagetop').addClass('is--visible');
		}else if(top <= 500){
			$('.btn--pagetop').removeClass('is--visible');
		}
	});

	$(document).on('click', '.btn--pagetop',function(e){
		e.preventDefault();
		$( 'html,body' ).animate( { scrollTop: 0 }, 'swing' );
	});
});



// WEBPACK FOOTER //
// ./es2015/app.js